export const moneyFormat = (value: number | undefined | string) => {
  if (typeof value === "string") {
    return parseFloat(value).toLocaleString();
  } else if (typeof value === "number") {
    return value.toLocaleString();
  } else {
    return "-";
  }
};
